/**
 * Created by Ning Jiang on 2/5/2019.
 */

import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";
import {TombstoneFreespinOutroView} from "./TombstoneFreespinOutroView";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneGameMode} from "../../gamemode/TombstoneGameMode";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";
import {TombstoneNoMercy} from "../../TombstoneNoMercy";

export class TombstoneFreespinOutroController extends FreespinOutroController {

    constructor(config:IScreenConfig) {
        super(config);
        (<TombstoneFreespinOutroView>this._view).getPlaySoundCallback(() => this.playMainSound());
    }

    protected calculateIsTriggered(data: TombstoneParsedGameData): boolean {
        return !data.brokeTheBank && (data.mode === TombstoneGameMode.FREESPIN && data.freespinsLeft === 0);
    }

    private playMainSound():void {
        SlotGame.sound.playAmbience(TombstoneSoundConfig.instance.MAIN_GAME_AMBIANCE);
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.fadeAmbience(1, 5000);

        // #277
        if (!(SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && TombstoneGameModuleConfig.gameData.isWinBelowStake())) {
            SlotGame.sound.playEffect(this._serverData!.totalWin > 0 ? TombstoneSoundConfig.instance.GUNSLINGER_OUTRO : TombstoneSoundConfig.instance.GUNSLINGER_NOWIN_OUTRO);
        }
    }

    protected showKeypad() {
        SlotGame.keypad.show();
        if (!(SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && TombstoneGameModuleConfig.gameData.isWinBelowStake())) {
            TombstoneNoMercy.keypad.setWin(TombstoneGameModuleConfig.gameData!.accumulatedRoundWin, true, TombstoneGameModuleConfig.gameData.isWinBelowStake());
        }
    }
}